// Which language a given patient is communicated with.
//
// Two gates, both of which must be open:
//   1. the clinic opted in (`clinic.englishCommunicationEnabled`)
//   2. the patient was explicitly marked (`patient.communicationLanguage`)
// Either one absent — which is the case for every clinic and patient that
// existed before this feature — means Hebrew.

export const PATIENT_LANGUAGES = { HE: "he", EN: "en" };

export const PATIENT_LANGUAGE_OPTIONS = [
  { value: PATIENT_LANGUAGES.HE, label: "עברית" },
  { value: PATIENT_LANGUAGES.EN, label: "אנגלית" },
];

/**
 * @param {object|null} patient patient doc (temp customers have none)
 * @param {boolean} englishCommunicationEnabled from selectEnglishCommunicationEnabled
 * @returns {"he"|"en"}
 */
export const getPatientLanguage = (patient, englishCommunicationEnabled) =>
  englishCommunicationEnabled === true && patient?.communicationLanguage === "en"
    ? PATIENT_LANGUAGES.EN
    : PATIENT_LANGUAGES.HE;

/** Normalize a raw field value for writing. Anything but "en" is Hebrew. */
export const normalizePatientLanguage = (value) =>
  value === PATIENT_LANGUAGES.EN ? PATIENT_LANGUAGES.EN : PATIENT_LANGUAGES.HE;
